<template>
  <div>
    <b-row>
      <b-table
        ref="selectableTable"
        id="table-id"
        hover
        :items="data"
        :fields="tableFields"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      ></b-table>
    </b-row>
    <b-row>
      <b-col sm="4" md="4" lg="4">
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="rows"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-id"
        ></b-pagination>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <label
          for="perPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{rows}}</label>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <b-row>
          <b-col sm="3" md="3" lg="3">
            <b-form-select v-model="tablePerPage" id="perPageSelect" size="sm" :options="tablePageOptions"></b-form-select>
          </b-col>
          <b-col style="padding-left: 0px;">
            <label for="perPageSelect">registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "CteImportDetails",
  props: {
    id: Number,
    lastRefresh: Date,
  },
  created: function () {
    this.loadData();
  },
  data: function () {
    return {
      data: null,
      tableFields: [
        {
          label: "Nome do arquivo",
          key: "nomeArquivo",
          sortable: true,
        },
        {
          label: "Descrição da ocorrência",
          key: "descricao",
          sortable: true,
        },
      ],
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    rows() {
      if (this.data) {
        return this.data.length;
      }
      return 0;
    },
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.rows) return this.rows;
      return to;
    },
  },
  watch: {
    id() {
      this.loadData();
    },
    lastRefresh() {
      this.loadData();
    },
  },
  methods: {
    async loadData() {
      this.$api
        .get("/cte/storyDetails/" + this.id.toString())
        .then((response) => {
          this.data = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>